import React from "react";

import "./styles.css";

interface PageHeaderProps {
  title: string;
  description?: string;
}

const PageHeader = ({ title, description }: PageHeaderProps) => (
  <header className="page-header">
    <h1>{title}</h1>
    {description && <p>{description}</p>}
  </header>
);

export default PageHeader;
